<script>
export default {
    name: "ProductCharacteristicsFeature",
    props: {
        title: { type: String, required: true },
        // можно передать строку, число или массив значений
        description: { required: true, type: [String, Number, Array] },
        bgColor: { type: String, default: 'bg-white' }
    },
    computed: {
        text() {
            if (Array.isArray(this.description)) {
                return this.description.join(' / ')
            }
            if (this.description === null || this.description === undefined || this.description === '') {
                return '—'
            }
            return String(this.description)
        }
    }
}
</script>

<template>
    <div class="group relative flex items-center justify-between dotted_line font-medium text-sm">
        <div class="z-1 pe-1 transition text-gray-600" :class="[bgColor]">
            {{ title }}
        </div>
        <div class="z-1 ps-1 transition text-right text-gray-900 font-semibold" :class="[bgColor]">
            {{ text }}
        </div>
    </div>
</template>

<style scoped lang="scss">
.z-1 { z-index: 1; }
.dotted_line:before {
    content: '';
    width: 100%;
    position: absolute;
    bottom: 5px;
    left: 0;
    border-bottom: 1px dotted #515151;
    transition: .25s;
}
</style>
